import React from "react";
import { Link } from "react-router-dom";
import { Clock, Users, ArrowUpRight, Flame } from "lucide-react";

const RecipeCard = ({ recipe, index = 0, variant = "default" }) => {
    const total = (recipe.prep_time_minutes || 0) + (recipe.cook_time_minutes || 0);
    const delayClass = `hl-delay-${Math.min(5, (index % 5) + 1)}`;
    const showEpisode = recipe.featured && recipe.episode;
    const epLabel = showEpisode ? String(recipe.episode).padStart(2, "0") : null;

    return (
        <Link
            to={`/recipes/${recipe.slug}`}
            data-testid={`recipe-card-${recipe.slug}`}
            className={`group block hl-fade-up ${delayClass}`}
        >
            <div className={`relative hl-zoom-wrap rounded-sm bg-hl-tinted hl-shadow-warm ${variant === "tall" ? "aspect-[3/4]" : "aspect-[4/5]"}`}>
                <img
                    src={recipe.hero_image}
                    alt={recipe.title}
                    loading="lazy"
                    className="w-full h-full object-cover"
                />
                {showEpisode ? (
                    <div
                        data-testid={`recipe-card-episode-${recipe.slug}`}
                        className="absolute top-4 left-4 flex items-center gap-2 px-3 py-1.5 bg-hl-brown/85 backdrop-blur-sm border border-[#E8D9B5]/30 rounded-sm"
                    >
                        <span className="font-script text-[#E8D9B5] text-base leading-none">ep.</span>
                        <span className="font-serif text-hl-bg text-sm tracking-[0.18em] leading-none">{epLabel}</span>
                    </div>
                ) : null}
            </div>
            <div className="mt-6 px-1">
                <div className="flex items-center gap-2.5 text-[10px] uppercase tracking-[0.22em] text-hl-muted">
                    <span data-testid={`recipe-origin-${recipe.slug}`}>{recipe.origin}</span>
                    <span className="w-[3px] h-[3px] rounded-full bg-hl-secondary" />
                    <span className="flex items-center gap-1.5"><Clock className="w-3 h-3" strokeWidth={1.5} /> {total} min</span>
                    <span className="w-[3px] h-[3px] rounded-full bg-hl-secondary" />
                    <span className="flex items-center gap-1.5"><Flame className="w-3 h-3" strokeWidth={1.5} /> {recipe.difficulty || "Easy"}</span>
                </div>
                <h3 className="mt-2.5 font-serif text-2xl md:text-3xl text-hl-brown group-hover:text-hl-secondary transition-colors duration-500 leading-tight">
                    {recipe.title}
                </h3>
                <p className="mt-2 text-hl-muted text-sm leading-relaxed line-clamp-2">
                    {recipe.short_description}
                </p>
                <span className="inline-flex items-center gap-1.5 mt-4 text-xs uppercase tracking-[0.22em] text-hl-secondary group-hover:gap-3 transition-all duration-500">
                    Read the story <ArrowUpRight className="w-3 h-3" strokeWidth={1.5} />
                </span>
            </div>
        </Link>
    );
};

export default RecipeCard;
